<div class="flex min-h-screen flex-col gap-6 p-6 pt-2">
  @if (errorOfferData() && !loadingOfferData()) {
    <app-error-data [title]="errorOfferData()!" />
  }

  @if (offerData() && !loadingOfferData()) {
    <div *hasScope="scopes.OFFERS.READ_BY_ID">
      <h1 class="offerTitle text-[32px] leading-tight font-[700]">
        {{ isArabic() ? offerData()?.titleAr || "غير متوفر" : offerData()?.titleEn || "Not Provided" }}
      </h1>

      <div class="flex w-full items-center justify-center gap-8 rounded-[16px] p-6 pt-2">
        <app-image-carousel type="offer" [profileImage]="offerImageUrl()" [isLoading]="loadingOfferData()" />
      </div>
    </div>
  } @else if (loadingOfferData()) {
    <app-loading />
  }

  @if (!errorOfferData() && !loadingOfferData()) {
    <div class="border-b border-gray-200" *hasScope="scopes.OFFERS.READ_BY_ID">
      <nav class="flex gap-4">
        <button
          (click)="setActiveTab('details')"
          [ngClass]="
            activeTab() === 'details' ? 'borderTabsColor textTabsColor border-b-2' : 'border-transparent text-gray-500'
          "
          class="cursor-pointer pb-2 text-[14px] font-medium"
          i18n="@@adminOffersActionView">
          Offer Details
        </button>
        <button
          (click)="setActiveTab('included-items')"
          [ngClass]="
            activeTab() === 'included-items'
              ? 'borderTabsColor textTabsColor border-b-2'
              : 'border-transparent text-gray-500'
          "
          class="cursor-pointer pb-2 text-[14px] font-medium"
          i18n="@@includedItems">
          Included Items
        </button>
      </nav>
    </div>

    <div>
      @if (activeTab() === "details") {
        <app-offer-details-tab [offer]="offerData()!" />
      } @else if (activeTab() === "included-items") {
        <app-offer-included-items-tab [offer]="offerData()!" />
      }
    </div>
  }
</div>
